import { Link } from "react-router-dom";

export const DownloadJson = () => {
  return (
    <Link to="/tcf.json" download target="_blank">
      Download JSON
    </Link>
  );
};
